module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "chap_num",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Contents#rsec2"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "chap_head"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Contents#rsec2"
    }
  }, [_c('i', [_vm._v("Adolf Hitler’s Bequest")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICANS TRAVEL TO THE BATTLEFIELD AT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORMANDY")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" Pointe du Hoc, invariably they visit the nearby cemetery where US soldiers are buried. There lie ten thousand men who gave their lives for the cause of freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The graveyard most people do not see is nine miles east, at La Cambe, one of six where the German dead rest. It is even more moving than the American burial ground. There lie more than twenty-one thousand men—many who, at the time of their deaths, were in their midteens, others as old as seventy. Most of them had been conscripted into a war that none had ever wanted, for a regime many did not believe in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("They were there because Reichsmarschall Hermann Göring, known by some of the other generals as Fat Boy, had been losing a secret battle with a onetime champagne salesman named Joachim von Ribbentrop, who had become Germany’s foreign minister.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("As a result, in August 1939, Adolf Hitler made one of the most tragic decisions in history.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d76d7b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253061973_Introduction.vue
// module id = 78
// module chunks = 0